export default __webpack_public_path__ + "media/zurb/img/events/wired/lsa/lsa-thumb-065afe38c5e1718e72a6acb92f59f293.png";